import { HttpService } from '@Services/index';
import { useBoundStore } from '@Store/index.ts';
import type { OnboardingStatus } from '@Store/index.ts';
import type { MFA_TYPES } from '@Types/types';

interface WebAppLoginPayload {
  loginName: string;
  password: string;
}

export interface WebAppLoginResponse {
  customerId: string;
  status: OnboardingStatus;
  loginResponseCustomData: Record<string, unknown>;
  mfaType: MFA_TYPES;
  mfaDestination: string;
  remmberMe?: boolean;
}

export const webAppLogin = async (payload: WebAppLoginPayload) => {
  const url = 'v2/user/openauth/login/silent';

  const { data } = await HttpService.post<WebAppLoginResponse>(url, {
    ...payload,
    clientId: import.meta.env.VITE_CLIENT_ID,
    fingerPrint: (window as unknown as { fpId: string }).fpId,
  });
  return data;
};

export interface VerifyMfaPayload {
  answer: string;
  customData: Record<string, unknown>;
  mfaType: MFA_TYPES;
  rememberMe: boolean;
}

export interface VerifyMfaResponse {
  customerId: string;
}

export const verifyMfa = async ({ answer, customData, mfaType, rememberMe }: VerifyMfaPayload) => {
  const { customerId } = useBoundStore.getState().customer;
  const { data } = await HttpService.post<VerifyMfaResponse>(
    `v1/user/openauth/${customerId}/login/mfa/silent`,
    {
      answer: answer,
      clientId: import.meta.env.VITE_CLIENT_ID,
      customData: customData,
      mfaType: mfaType,
      rememberMe: rememberMe,
    }
  );

  return data;
};
